import React from "react";
import SofIcon from "../common/Icons";
import { DefaultButton, mergeStyleSets } from "@fluentui/react";

type Props = {
  onRefresh: () => void;
};
const classes = mergeStyleSets({
  container: {
    // position: "absolute",
    // bottom: 0,
    // top: 0,
    // left: 0,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    height: "100%"
  },
  innerContainer: {
    width: 250,
    height: 350
  },
  icon: {
    width: 88,
    height: 88,
    borderRadius: 44,
    margin: "auto",
    backgroundColor: "rgb(240,153,13,0.3)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  title: {
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: 18,
    lineHeight: 22,
    letterSpacing: "0.005em",
    color: "#B8B8B8"
  },
  message: {
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: 14,
    lineHeight: 20,
    textAlign: "center",
    letterSpacing: "0.0025em",
    color: "#B8B8B8"
  },
  button: {
    height: 40,
    width: 152,
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: "0.0125em",
    textTransform: "capitalize",
    color: "#FFFFFF",
    background: "#009FDF",
    border: "1px solid #009FDF"
  }
});

const NoDataPane = (props: Props) => {
  return (
    <div className={classes.container}>
      <div className={classes.innerContainer}>
        <div className={classes.icon}>
          <SofIcon iconname={"Offline"} />
        </div>
        <div>
          <span className={classes.title}>You are offline</span>
          <p className={classes.message}>
            No data available at the moment. Please connect to the internet and
            refresh to view the details.
                  </p>
                  <DefaultButton
                      onClick={props.onRefresh}
                      text="Refresh"
                  />
          {/*<button className={classes.button} onClick={props.onRefresh}>*/}
          {/*  Refresh*/}
          {/*</button>*/}
        </div>
      </div>
    </div>
  );
};
export default NoDataPane;
